angular.module("ainapp")
    .controller("UserPageRoleController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "User Page Role";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }


            $scope.GetEmployeePageRoleDetails = function (userId) {

                $scope.Load = true;
                $scope.Pages = angular.copy($scope.PageList);

                MainService.GetEmployeePageRoleDetails(userId).then(function (response) {
                    if (response.data != null) {

                        if (response.data.length == 0) {

                            angular.forEach($scope.Pages, function (a) {
                                a.IsOpen = true;
                                angular.forEach(a.Pages, function (e) {
                                    e.PageName = e.Name;
                                    e.IsAccess = false;
                                    e.IsAdd = false;
                                    e.IsEdit = false;
                                    e.IsRemove = false;
                                    e.IsPrint = false;
                                    e.IsView = false;
                                    e.IsViewByUser = false;
                                    e.UserId = userId;
                                    e.PageGroup = e.Type;
                                    //$scope.PageArray.push(e);
                                });
                            });




                        } else {

                            angular.forEach($scope.Pages, function (aa) {

                                aa.IsOpen = true;

                                angular.forEach(aa.Pages, function (e) {

                                    var flag = 0;
                                    var selData = {};

                                    angular.forEach(response.data, function (a) {
                                        if (a.PageName == e.Name) {
                                            flag = 1;
                                            selData = a;
                                        }
                                    });

                                    if (flag == 1) {
                                        e.PageName = e.Name;
                                        e.IsAccess = selData.IsAccess;
                                        e.UserId = userId;
                                        e.IsAdd = selData.IsAdd;
                                        e.IsEdit = selData.IsEdit;
                                        e.IsRemove = selData.IsRemove;
                                        e.IsPrint = selData.IsPrint;
                                        e.IsView = selData.IsView;
                                        e.IsViewByUser = selData.IsViewByUser;
                                        e.PageGroup = e.Type;
                                    } else {
                                        e.PageName = e.Name;
                                        e.IsAccess = false;
                                        e.UserId = userId;
                                        e.IsAdd = false;
                                        e.IsEdit = false;
                                        e.IsRemove = false;
                                        e.IsPrint = false;
                                        e.IsView = false;
                                        e.IsViewByUser = false;
                                        e.PageGroup = e.Type;
                                    }

                                });

                            });



                        }

                    } else {
                        toastr.error($scope.FailedLan);
                    }
                    $scope.Load = false;
                }, function (err) {
                    $scope.Load = false;
                    toastr.error($scope.NetworkErrorLan);
                });

            }

            $scope.setCompleteAccess = function () {
                angular.forEach($scope.Pages, function (aa) {
                    angular.forEach(aa.Pages, function (e) {
                        e.PageName = e.Name;
                        e.IsAccess = true;
                        e.IsAdd = true;
                        e.IsEdit = true;
                        e.IsRemove = true;
                        e.IsPrint = true;
                        e.IsView = true;
                        e.IsViewByUser = true;
                        e.UserId = $scope.ViewVal;
                        e.PageGroup = e.Type;
                    });
                });
            }


            $scope.removeCompleteAccess = function () {
                angular.forEach($scope.Pages, function (aa) {
                    angular.forEach(aa.Pages, function (e) {
                        e.PageName = e.Name;
                        e.IsAccess = false;
                        e.IsAdd = false;
                        e.IsEdit = false;
                        e.IsRemove = false;
                        e.IsPrint = false;
                        e.IsView = false;
                        e.IsViewByUser = false;
                        e.UserId = $scope.ViewVal;
                        e.PageGroup = e.Type;
                    });
                });
            }

            $scope.setCompleteAccessGroup = function (group) {
                angular.forEach($scope.Pages, function (aa) {
                    if (aa.Category == group) {
                        angular.forEach(aa.Pages, function (e) {
                            e.PageName = e.Name;
                            e.IsAccess = true;
                            e.IsAdd = true;
                            e.IsEdit = true;
                            e.IsRemove = true;
                            e.IsPrint = true;
                            e.IsView = true;
                            e.IsViewByUser = true;
                            e.UserId = $scope.ViewVal;
                            e.PageGroup = e.Type;
                        });
                    }
                });
            }


            $scope.removeCompleteAccessGroup = function (group) {
                angular.forEach($scope.Pages, function (aa) {
                    if (aa.Category == group) {
                        angular.forEach(aa.Pages, function (e) {
                            e.PageName = e.Name;
                            e.IsAccess = false;
                            e.IsAdd = false;
                            e.IsEdit = false;
                            e.IsRemove = false;
                            e.IsPrint = false;
                            e.IsView = false;
                            e.IsViewByUser = false;
                            e.UserId = $scope.ViewVal;
                            e.PageGroup = e.Type;
                        });
                    }
                });
            }


            $scope.setIsAccessAll = function (temp) {

                angular.forEach($scope.Pages, function (aa) {
                    if (aa.Category == temp) {

                        if (aa.IsAccessAll) {
                            angular.forEach(aa.Pages, function (e) {
                                e.IsAccess = true;
                            });
                        } else {

                            angular.forEach(aa.Pages, function (e) {
                                e.IsAccess = false;
                            });
                        }

                    }
                });


            }

            $scope.setIsAddAll = function (temp) {

                angular.forEach($scope.Pages, function (aa) {
                    if (aa.Category == temp) {

                        if (aa.IsAddAll) {
                            angular.forEach(aa.Pages, function (e) {
                                e.IsAdd = true;
                            });
                        } else {

                            angular.forEach(aa.Pages, function (e) {
                                e.IsAdd = false;
                            });
                        }

                    }
                });

            }

            $scope.setIsEditAll = function (temp) {

                angular.forEach($scope.Pages, function (aa) {
                    if (aa.Category == temp) {

                        if (aa.IsEditAll) {
                            angular.forEach(aa.Pages, function (e) {
                                e.IsEdit = true;
                            });
                        } else {

                            angular.forEach(aa.Pages, function (e) {
                                e.IsEdit = false;
                            });
                        }

                    }
                });

            }

            $scope.setIsViewAll = function (temp) {

                angular.forEach($scope.Pages, function (aa) {
                    if (aa.Category == temp) {

                        if (aa.IsViewAll) {
                            angular.forEach(aa.Pages, function (e) {
                                e.IsView = true;
                            });
                        } else {

                            angular.forEach(aa.Pages, function (e) {
                                e.IsView = false;
                            });
                        }

                    }
                });

            }

            $scope.setIsViewByUserAll = function (temp) {

                angular.forEach($scope.Pages, function (aa) {
                    if (aa.Category == temp) {

                        if (aa.IsViewByUserAll) {
                            angular.forEach(aa.Pages, function (e) {
                                e.IsViewByUser = true;
                            });
                        } else {

                            angular.forEach(aa.Pages, function (e) {
                                e.IsViewByUser = false;
                            });
                        }

                    }
                });

            }

            $scope.setIsPrintAll = function (temp) {

                angular.forEach($scope.Pages, function (aa) {
                    if (aa.Category == temp) {

                        if (aa.IsPrintAll) {
                            angular.forEach(aa.Pages, function (e) {
                                e.IsPrint = true;
                            });
                        } else {

                            angular.forEach(aa.Pages, function (e) {
                                e.IsPrint = false;
                            });
                        }

                    }
                });

            }

            $scope.setIsRemoveAll = function (temp) {

                angular.forEach($scope.Pages, function (aa) {
                    if (aa.Category == temp) {

                        if (aa.IsRemoveAll) {
                            angular.forEach(aa.Pages, function (e) {
                                e.IsRemove = true;
                            });
                        } else {

                            angular.forEach(aa.Pages, function (e) {
                                e.IsRemove = false;
                            });
                        }

                    }
                });

            }


            $scope.switchTab = function (tab, type) {

                $scope.IsAccessAll = false;
                $scope.IsAddAll = false;
                $scope.IsEditAll = false;
                $scope.IsViewAll = false;
                $scope.IsViewByUserAll = false;
                $scope.IsPrintAll = false;
                $scope.IsRemoveAll = false;

                $scope.ViewVal = tab;
                $scope.ViewValType = type;
                $scope.GetEmployeePageRoleDetails(tab);

            }

            $scope.init = function () {

                $scope.UserPRole = {
                    UserRoleId: "",
                    PageName: "",
                    IsSelectedInActive: false,
                    IsSelectedActive: true,
                }

                $scope.Users = [];
                MainService.EmployeeUsersInDropDown().then(function (response) {
                    $scope.Users = response.data;
                    if (response.data != null) {
                        $scope.switchTab(response.data[0].Id, response.data[0].Employee.Name);
                    }
                });

                $scope.ViewVal = 0;
                $scope.Load = false;


            }
            $scope.init();




            $scope.saveAccess = function (data) {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                MainService.AddUserPageRole(data).then(function (response) {
                    if (response.data) {
                        toastr.success("Success");
                        $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                    } else {
                        toastr.error("Failed");
                    }

                    $.LoadingOverlay("hide");
                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                });
            }


            $scope.saveAccessAll = function () {

                angular.forEach($scope.Pages, function (aa) {

                    var length = 0;

                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });

                    angular.forEach(aa.Pages, function (data) {

                        MainService.AddUserPageRole(data).then(function (response) {
                            length = length + 1;
                            if (aa.Pages.length == length) {
                                toastr.success("Success " + aa.Category);
                                $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                                $.LoadingOverlay("hide");
                            }
                        }, function (err) {
                            $.LoadingOverlay("hide");
                            toastr.error("Network Error");
                        });

                    })

                })

            }


            $scope.saveAccessAllGroup = function (group) {

                angular.forEach($scope.Pages, function (aa) {

                    if (aa.Category == group) {
                        var length = 0;

                        $.LoadingOverlay("show", {
                            image: "images/load.gif",
                        });

                        angular.forEach(aa.Pages, function (data) {

                            MainService.AddUserPageRole(data).then(function (response) {
                                length = length + 1;
                                if (aa.Pages.length == length) {
                                    toastr.success("Success " + aa.Category);
                                    $scope.switchTab($scope.ViewVal, $scope.ViewValType);
                                    $.LoadingOverlay("hide");
                                }
                            }, function (err) {
                                $.LoadingOverlay("hide");
                                toastr.error("Network Error");
                            });

                        })
                    }

                })

            }









      }]);
